export const poundPerFootToInchScalar = 1;

export const poundToInchScalar = 0.025;
